import {Injectable} from "@angular/core";
import {FamiliesService} from "../families.service";
import {Http} from "@angular/http";
import {UrlService} from "../url.service";
import {AuthentService} from "../authent.service";
import {Observable} from "rxjs";
import {Transaction} from "../../model/bill/transaction";

@Injectable()
export class StripeService extends FamiliesService {

  constructor(private http: Http, private urlService: UrlService, private authent: AuthentService) {
    super();
  }

  stripeOrder(sourceId: string, premiumType: string, eventId: string, businessId: number): Observable<void> {
    return this.http.post(this.urlService.getStripeOrderUrl(sourceId, premiumType, eventId, businessId), null, this.authent.getJSONAuthentHeaders())
      .catch(this.handleError);
  }

  openTransaction(premiumType: string, eventId: string, businessId: number) {
    return this.http.post(this.urlService.getOpenStripeTransactionUrl(premiumType, eventId, businessId), null, this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  cancelSubscription(businessId: number): Observable<void> {
    return this.http.delete(this.urlService.getStripeCancelUrl(businessId), this.authent.getJSONAuthentHeaders())
      .catch(this.handleError);
  }

  getTransaction(intentId: string, businessId: number): Observable<Transaction> {
    return this.http.get(this.urlService.getTransactionByIntentUrl(intentId, businessId), this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  subscription(token: string, itemType: string, businessId: number) {
    let body = {
      token: token,
      premiumType: itemType
    };

    return this.http.post(this.urlService.getStripeBusinessSubscriptionUrl(businessId), body, this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/data/stripe.service.ts